import React, { ChangeEventHandler } from 'react';
import { Form } from 'react-bootstrap';
import { JurisdictionState } from '../types';

/**
 * jurisdictionFormコンポーネント用のPropsです。
 * @interface jurisdictionFormProps
 */
interface JurisdictionFormProps {

  /**
   * 委任事項の索引
   * @type {number}
   * @memberof jurisdictionFormProps
   */
  appointmentIndex: number;

  /**
   * 委任事項ID
   * @type {string}
   * @memberof jurisdictionFormProps
   */
  appointmentId: string;

  /**
   * 法域の索引
   * @type {number}
   * @memberof jurisdictionFormProps
   */
  jurisdictionIndex: number;

  /**
   * 法域
   * @type {JurisdictionState}
   * @memberof jurisdictionFormProps
   */
  jurisdiction: JurisdictionState;

  /**
   * チェック状態を設定する関数
   * @memberof jurisdictionFormProps
   */
  onChange: (appointmentIndex: number, jurisdictionIndex: number, isChecked: boolean) => void;

  /**
   * 表示有無
   * @memberof jurisdictionFormProps
   */
  disabled: boolean;
}

/**
 * 法域フォームのコンポーネントです。
 * @param {number} props.appointmentIndex - 委任事項の索引
 * @param {string} props.appointmentId - 委任事項ID
 * @param {number} props.jurisdictionIndex - 法域の索引
 * @param {Jurisdiction} props.jurisdiction - 法域
 * @param {function} props.onChange - チェック状態が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 法域フォームのJSX要素
 */
const JurisdictionForm: React.FC<JurisdictionFormProps> = ({appointmentIndex, appointmentId, jurisdictionIndex, jurisdiction, onChange, disabled }) => {

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event): void => {
    const updatedIsChecked: boolean = event.target.checked;
    onChange(appointmentIndex, jurisdictionIndex, updatedIsChecked);
  }

  return (
    <Form.Group
      className={`ms-4${disabled ? ' d-none' : ''}`}
      controlId={`appointment${appointmentId}Jurisdiction${jurisdiction.jurisdictionCode}`}
      aria-disabled={disabled}
    >
      <Form.Check
        type="checkbox"
        label={jurisdiction.label}
        value={jurisdiction.value} 
        onChange={handleChange}
        checked={jurisdiction.isChecked}
      />
    </Form.Group>
  );
}

export default JurisdictionForm;